import { render } from "./ProductModifierItem.vue?vue&type=template&id=bb7f4678&scoped=true&ts=true"
import script from "./ProductModifierItem.vue?vue&type=script&lang=ts"
export * from "./ProductModifierItem.vue?vue&type=script&lang=ts"

import "./ProductModifierItem.vue?vue&type=style&index=0&id=bb7f4678&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb7f4678"]])

export default __exports__